// src/context/useAuth.ts

import api from "../api/axios";

export interface AuthUser {
  email: string;
}

interface AuthState {
  user: AuthUser | null;
  loading: boolean;
}

let state: AuthState = {
  user: null,
  loading: true,
};

export const useAuth = () => {
  return {
    get user(): AuthUser | null {
      return state.user;
    },

    get loading(): boolean {
      return state.loading;
    },

    init: async (): Promise<void> => {
      state.loading = true;

      try {
        // Establish the CSRF cookie through the Vite proxy locally.
        await api.get("/api/auth/csrf/", {
          validateStatus: (status) => status < 500,
        });

        // Check the current Django session.
        const response = await api.get("/api/auth/me/", {
          validateStatus: (status) => status < 500,
        });

        if (response.status === 200 && response.data?.email) {
          state.user = {
            email: response.data.email,
          };
        } else {
          // A 401 simply means the visitor is currently signed out.
          state.user = null;
        }
      } catch (error) {
        console.warn("Authentication initialization failed:", error);
        state.user = null;
      } finally {
        // Always allow the frontend to render.
        state.loading = false;
      }
    },

    logout: async (): Promise<void> => {
      try {
        await api.post("/api/auth/logout/", undefined, {
          validateStatus: (status) => status < 500,
        });
      } catch (error) {
        console.warn("Logout request failed:", error);
      } finally {
        state.user = null;

        window.location.href =
          "https://api.ayesearch.com/auth/ayesearch/login/";
      }
    },
  };
};
